import { postRequest } from "../../config/AxiosConfig";
import API_URLS from "../../config/BackendConfig";
import { getAuthToken } from "../../utils/tokenUtils";

//  Payout List Report
export const RetrievePayouts = async (
  page = 1,
  filters = {
    total_data: 10,
    account_number: "",
    beneficiary_name: "",
    amount: 0,
    from_date: "",
    to_date: "",
    txn_type: ""
  }
) => {
  try {
      const token = getAuthToken();
    const response = await postRequest({
      url: `${API_URLS.ADMIN}payout/list?page=${page}`,
      headers: { Authorization: `Bearer ${token}` },
      data: filters 
    });
    return response;
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || "Failed to get List",
    };
  }
};


export const UpdateTxn = async ({id,new_status})  => {
  try {
    const payload = {
    "payout_id": id, 
    "new_status" : new_status              //"success|failed"
}
     const token = getAuthToken();
     const response = await postRequest({
      url:  `${API_URLS.ADMIN}payout/transaction/update`,
      headers: {Authorization: `Bearer ${token}`},
      data : payload
     })        
     return response;           
  } catch (error) {
     return {
      success: false,
      message: error.response?.data?.message || "Failed to update txn status",
    };
  }
}



export const ReponseStatusTxn = async ({id})  => {
  try {
    const payload = {
    "payout_id": id, 
}
     const token = getAuthToken();
     const response = await postRequest({
      url:  `${API_URLS.ADMIN}payout/transaction/status`,
      headers: {Authorization: `Bearer ${token}`},
      data : payload
     })        
     return response;           
  } catch (error) {
     return {
      success: false,
      message: error.response?.data?.message || "Failed to txn Response",
    };
  }
}

// that service add for reponse only and shows in modeal when click on txnStatus button